module.exports = __webpack_public_path__ + "img/icon_assembleP.a9ea410f.svg";